var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcpLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 234.92323,
    height: 79.42463,
    viewBox: "0 0 234.92323 79.42463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fd5ef8a4-94a4-46f8-b53c-f1bec0144c49",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ac184668-76da-456a-bd23-1aac3ea5452b",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.45789.25441A5.47389,5.47389,0,0,0,0,5.71224V32.78749L30.83679.25441Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.80018,40.919a20.73,20.73,0,0,0,13.39355-4.5459l6.75782,10.8125A34.884,34.884,0,0,1,97.308,53.207c-17.57129,0-28.50781-10.32226-28.50781-26.542C68.80018,10.69043,79.85975,0,94.60487,0,108.12147,0,118.935,9.09375,118.935,24.45312a55.34465,55.34465,0,0,1-.36817,6.02149H84.16053C84.77479,37.60156,90.67323,40.919,97.80018,40.919ZM84.40565,19.53809h21.01269c-.86035-5.5293-4.66992-8.84766-10.32226-8.84766C89.68983,10.69043,85.88026,14.13184,84.40565,19.53809Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.60389,26.665C123.60389,9.2168,135.40077,0,151.12928,0c9.83008,0,16.21973,3.31836,16.58789,3.56348l-1.35156,12.41113a26.581,26.581,0,0,0-13.27051-3.68652c-7.25,0-14.00781,4.42382-14.00781,14.13086,0,9.708,6.63476,14.25488,13.76172,14.25488a19.96024,19.96024,0,0,0,12.165-4.30078l6.14453,10.93554a34.6771,34.6771,0,0,1-19.90723,6.14454C135.03163,53.45313,123.60389,43.99121,123.60389,26.665Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.29627,25.80469c0,14.99121-8.72461,27.27929-24.207,27.27929a35.21679,35.21679,0,0,1-12.53418-2.58007V62.3784L175.94959,78.68861c-.123,6.06593,0-25.85072,0-77.70521H191.432V9.95312C192.78358,7.127,196.96229.12305,206.42323.12305,220.18592.12305,228.29627,10.44531,228.29627,25.80469Zm-25.92773-12.7793c-6.63574,0-10.93652,6.38965-10.93652,18.67774v6.38964a19.22594,19.22594,0,0,0,9.46191,2.70313c7.74121,0,11.55078-6.75781,11.55078-14.74512C212.44471,18.80078,209.61854,13.02539,202.36854,13.02539Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.92323,4.30469a3.34728,3.34728,0,1,1-6.69239-.01074,3.347,3.347,0,1,1,6.69239.01074ZM228.392,4.294a3.18619,3.18619,0,1,0,6.37011.01074A3.18593,3.18593,0,1,0,228.392,4.294Zm2.1914,2.07324h-.16113V2.25293h.36523c1.28907,0,2.11622.17187,2.11622,1.14941,0,.78418-.50489,1.05274-1.31055,1.12793,1.03125.24707.87012,1.38575,1.79394,1.67578l-.06445.13965c-1.085-.36523-.75195-1.79394-2.32031-1.79394h-.41895Zm.2041-1.9336c1.2461,0,1.98731-.10742,1.98731-1.03125,0-.87011-.73047-1.0205-1.98731-1.0205h-.2041V4.43359Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.22882.25441H40.24994L0,42.89577v5.45081a5.47393,5.47393,0,0,0,5.45789,5.45788h8.04882l40.18-42.56842V5.71224A5.4739,5.4739,0,0,0,48.22882.25441Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.68671,48.34658V20.88826L22.75922,53.80446h25.4696A5.47394,5.47394,0,0,0,53.68671,48.34658Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcpLogo);
export default __webpack_public_path__ + "static/media/ECP_logo.c14dd7190257f99893073f4839ecf402.svg";
export { ForwardRef as ReactComponent };